import { Chip, ChipProps } from "@mui/material"
import { ArticleResult } from "interface/article"

type ArticcleSourceChipProps = {
	source: ArticleResult['source']
} & ChipProps
export const ArticleSourceChip = ({
	source,
	...others
}: ArticcleSourceChipProps) => {
	return (
		source === 'pubmed' ? <img src={`${process.env.PUBLIC_URL}/pubMed.png`} alt='PubMed' height='24px'/> :
		source === 'ichusi' ? <img src={`${process.env.PUBLIC_URL}/ichusi.png`} alt='医中誌' height='24px'/> :
		source === 'ultmark' ? <Chip label='和論文' {...others}/> :
		<></>
	)
}